<template>
  <div class="pageBox ">
    <div class="pageBox_right">
      <span class="page_txt">Rows per page:</span>
      <el-select v-model="sizePage" class="size_page" @change="selectCurrentItem">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="page" :page-size="sizePage" layout="prev, next" :total="total"> </el-pagination>
  
    </div>
  </div>
</template>
<script>
export default {
  props: {
    totalFont: {
      type: Boolean,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
    watch: {
    currentPage(val) {
      this.page = val

    },
    pageSize(val) {
      this.sizePage = val
    }
  },
  data() {
    return {
     page: this.currentPage,
      sizePage: this.pageSize,
      options: [
      {
          value: 5,
          label: 5,
        },
        {
          value: 10,
          label: 10,
        },
        {
          value: 15,
          label: 15,
        },
    
      ],
      token: localStorage.getItem('token'),
    }
  },
  
  // computed: {
 
  //   page: {
  //     get() {
  //       return this.currentPage
  //     },
  //     set(val) { this.$emit('update', val) }
  //   },
  //   isPagin: {
  //     get() {
       
  //       let status=localStorage.getItem('token')?false:true
  //       return status
  //     },
  //     set() {},
  //   },
  // },
  destroyed(){
    // bus.$off('handleShowLogin');
  },


  methods: {
    handleCurrentChange(val) {
          this.$emit('update:currentPage', val)
      this.$emit('onPageChange', { page: val, size: this.sizePage })

  
    },
    // onFirst() {
    //   this.page = 1
    //   this.handleCurrentChange(1)
    // },
    // onLast() {
    //   const page = Math.ceil(this.total / this.pageSize)
    //   this.page = page
    //   this.handleCurrentChange(page)
    // },

    //切换一页显示几条
    selectCurrentItem(val) {
            this.$emit('update:pageSize', val)
      this.$emit('onPageChange', { page: 1, size: val })
    },


  },
}
</script>
<style scoped>
.totalFont {
  line-height: 18px;
 font-size: 1.14285714rem;
  color: #8398bb;
}

.page_txt {
 font-size: 1.14285714rem;
color: #999999;

}
.size_page {
  margin-right: 20px;
}
.size_page /deep/ .el-input__inner {
  width: 60px;
height: 24px;
background: #FFFFFF;
border-radius: 4px;
color: #1290C9;
border: 1px solid #CCCCCC;  font-size: 1.14285714rem;
padding-right: 0px !important;
}
.size_page /deep/ .el-icon-arrow-up:before {
 color: #999999;
  font-size: 1.14285714rem;
}
.el-select-dropdown__item {
  font-size: 1.14285714rem;
}
.size_page /deep/ .el-input__icon {
  width: 20px;
  line-height: 24px;
}
.firstBtn,
.lastBtn {
  width: 26px;
  height: 26px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e7eaed;
    font-size: 1.14285714rem;
}

button img {
  width: 10px;
  vertical-align: middle;
}
/* 分页 */
.pageBox /deep/ .el-pagination button,
.pageBox /deep/ .el-pagination button span:not([class*='suffix']) {
  display: inline;
  min-width: 24px !important;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border-radius: 4px;
    font-size: 1.14285714rem;
  border: 1px solid #CCCCCC;
}

.pageBox /deep/ .btn-prev {
  margin-right: 10px;
  padding-right: 6px;
}
.pageBox /deep/ .btn-next {
  padding-left: 6px;
}
.pageBox /deep/ .el-icon-arrow-right:before,
.pageBox /deep/ .el-icon-arrow-left:before {
  content: '';
}
.pageBox /deep/ .el-icon-arrow-right,
.pageBox /deep/ .el-icon-arrow-left {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 10px 9px;
  background-position: center;
}
.pageBox /deep/ .el-icon-arrow-left {
  background-image: url(../..//assets/img/search/pre_ic1.png);
}
.pageBox /deep/ button:disabled .el-icon-arrow-left {
  background-image: url(../../assets/img/search/pre_ic2.png);
}
.pageBox /deep/ .el-icon-arrow-right {
  background-image: url(../../assets/img/search/next_ic1.png);
}
.pageBox /deep/ button:disabled .el-icon-arrow-right {
  background-image: url(../../assets/img/search/next_ic2.png);
}
.new-content-right .pageBox /deep/ .el-icon-arrow-right ,.SourcSanctionsShow_dialog .pageBox /deep/ .el-icon-arrow-right {
  background-image: url(../../assets/img/search/yellow_arrow-right.png);
}
.new-content-right  .pageBox /deep/ .el-icon-arrow-left,.SourcSanctionsShow_dialog .pageBox /deep/ .el-icon-arrow-left{
  background-image: url(../../assets/img/search/yellow_arrow-left.png);
}

</style>
